import { HttpClient } from "@angular/common/http";
import { CachedTranslateHttpLoader } from "./cached-http-loader";
import { PortalsTranslationConfig } from "./portals-translation.module";

export function HttpLoaderFactory(http: HttpClient, config: PortalsTranslationConfig): CachedTranslateHttpLoader {
    return new CachedTranslateHttpLoader(
        http,
        config.translationsDeployUrl,
        '.json',
        config.cacheKey
    );
}
